/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/shipyard_1_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22 11l-6 12-6-12zM15 8h2v2h-2zM15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
